import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getCreateMilestoneError() {
      return getState().error;
    },
    isMilestoneCreationRequestFailure() {
      return getState().request.isFailure;
    },
    isMilestoneCreationRequestPending() {
      return getState().request.isPending;
    },
    isMilestoneCreationRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
